import { Field } from 'react-final-form';

const identity = (value) => value;

export const IdentityField = (props) => <Field parse={identity} {...props} />;
